import { TagLink } from '@bnnvara/tags';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import Link from '../Link';
import { ThemeTag } from '../Tags/ThemeTag';

import { TagTitle, TagListWrapper, TagThemeBullet } from './styled';

export const tagPropType = PropTypes.shape({
  slug: PropTypes.string,
  name: PropTypes.string,
});

const TagList = ({ tags, subThemes }) => {
  const showThemes = subThemes && subThemes.length > 0;
  const showTags = tags && tags.length > 0;

  if (!showTags && !showThemes) {
    return null;
  }

  return (
    <>
      {showThemes && (
        <TagListWrapper>
          <TagTitle>Thema&apos;s:</TagTitle>
          {subThemes.map((subTheme, index) => (
            <Fragment key={`fragment-${subTheme.slug}`}>
              <ThemeTag
                color={subTheme.color}
                colorHover={subTheme?.colorHover}
                colorActive={subTheme?.colorActive}
                colorVisited={subTheme?.colorVisited}
                size="sm"
                href={`/thema/${subTheme.parentSlug}/${subTheme.slug}`}
              >
                {subTheme.name}
              </ThemeTag>
              <TagThemeBullet key={`bullet-${subTheme.name}`}>
                {index < subThemes.length - 1 ? (
                  <span>&nbsp; &nbsp;</span>
                ) : null}
              </TagThemeBullet>
            </Fragment>
          ))}
        </TagListWrapper>
      )}
      {showTags && (
        <div>
          <TagTitle>Meer over:</TagTitle>
          {tags.map((tag, index) => (
            <Fragment key={`fragment-${tag.slug}`}>
              <Link
                href={`/tags/${tag.slug}`}
                category="Zoeken"
                label={`tags-${tag.slug}`}
                action="click"
                key={`link-${tag.slug}`}
              >
                <TagLink key={tag.slug}>{tag.name}</TagLink>
              </Link>
              <span key={`comma-${tag.slug}`}>
                {index < tags.length - 1 ? ', ' : null}
              </span>
            </Fragment>
          ))}
        </div>
      )}
    </>
  );
};

TagList.defaultProps = {
  tags: [],
};

TagList.propTypes = {
  tags: PropTypes.arrayOf(tagPropType),
  subThemes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      description: PropTypes.string,
      slug: PropTypes.string,
      color: PropTypes.string,
      colorHover: PropTypes.string,
      colorActive: PropTypes.string,
      colorVisited: PropTypes.string,
      backgroundImageUrl: PropTypes.string,
      backgroundImageMobileUrl: PropTypes.string,
      parentSlug: PropTypes.string,
      parent: {
        id: PropTypes.string,
        name: PropTypes.string,
        description: PropTypes.string,
        slug: PropTypes.string,
        color: PropTypes.string,
        colorHover: PropTypes.string,
        colorActive: PropTypes.string,
        colorVisited: PropTypes.string,
        backgroundImageUrl: PropTypes.string,
        backgroundImageMobileUrl: PropTypes.string,
      },
    })
  ),
};

export default TagList;
